import React from "react";
import { formatPhoneNumber2 } from "../../../utils";
import { OtpTextBox } from ".";
import {Typography} from "@one-thd/sui-atomic-components";

const OtpPhoneSmsView = (props) => {
  const {
    otpPhoneNumber
  } = props;

  return (
    <div>
      <Typography>
        We sent a verification code to your phone
      </Typography>
      <Typography weight='bold'>
        {formatPhoneNumber2(otpPhoneNumber)}
      </Typography>
      <OtpTextBox {...props} />
    </div>
  );
};

export default OtpPhoneSmsView;